import { onBeforeMount, onUnmounted, ref, unref, type MaybeRef } from 'vue'
import type { Message } from '#entities/message'
import { respondEventBus } from './respond-event-bus'

export function useRespondFor(chatId: MaybeRef<number>) {
  const respondFor = ref<Message | null>(null)

  const onRespondTriggered = (message: Message | null) => {
    respondFor.value = message
  }

  onBeforeMount(() => {
    respondEventBus.on(unref(chatId), onRespondTriggered)
  })

  onUnmounted(() => {
    respondEventBus.off(unref(chatId), onRespondTriggered)
  })

  return respondFor
}
